import React from 'react'
import { Chip } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { red, yellow, shade } from '../../../colors'

interface AnonymousSurveyChipProps {
  show?: boolean
}

export const AnonymousSurveyChip: React.FC<AnonymousSurveyChipProps> = ({ show = true }) => {
  if (!show) return null
  return (
    <Chip
      icon={<FiberManualRecordIcon sx={{ fontSize: '8px !important', color: red[800] + ' !important' }} />}
      label="Anonymous Survey"
      variant="outlined"
      size='small'
      sx={{
        borderColor: yellow[100] + ' !important',
        borderWidth: '1px',
        borderStyle: 'solid',
        backgroundColor: shade[1000],
        color: red[800],
        fontWeight: 500,
        borderRadius: '6px',
        fontSize: '12px'
      }}
    />
  )
}
